import React, { useState } from "react";
import { useRefinementList } from "react-instantsearch";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FacetModal from "./FacetModal";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export default function MultiLieuxFacet({ attribute, searchable, searchablePlaceholder, showMore, showMoreLimit, limit, ...rest }) {
  const {
    items,
    refine,
  } = useRefinementList({ attribute, limit: limit || 10, showMore: showMore || false, showMoreLimit: showMoreLimit || 100 });

  const [searchQuery, setSearchQuery] = useState("");
  const [openValais, setOpenValais] = useState(true);
  const [openHorsValais, setOpenHorsValais] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMounted, setModalMounted] = useState(false);

  // Ne rien afficher si la facette est vide
  if (!items || items.length === 0) return null;

  const filteredItems = searchQuery.trim() === ""
    ? items
    : items.filter(item => {
        const code = item.value.split("|");
        const label = (code[1] || item.value).toLowerCase();
        return label.includes(searchQuery.toLowerCase());
      });

  const valaisItems = filteredItems.filter(item => item.value && item.value.substring(0, 4) === "chvs");
  const horsValaisItems = filteredItems.filter(item => item.value && item.value.substring(0, 4) !== "chvs");

  const renderItem = (item) => {
    const code = item.value.split("|");
    let displayLabel = code[1] || item.value;
    if (displayLabel === "Valais") { displayLabel = "Valais (région)"; }

    return (
      <label key={item.value} className="sui-multi-checkbox-facet__option-label" style={{ display: "flex", alignItems: "center", paddingLeft: "24px" }}>
        <div className="sui-multi-checkbox-facet__option-input-wrapper" style={{ flex: 1 }}>
          <input
            type="checkbox"
            className="sui-multi-checkbox-facet__checkbox"
            checked={item.isRefined}
            onChange={() => refine(item.value)}
          />
          <span className="sui-multi-checkbox-facet__input-text" style={{ marginLeft: "8px" }}>
            {displayLabel}
          </span>
        </div>
        <span className="sui-multi-checkbox-facet__option-count">
          {item.count.toLocaleString("fr-CH")}
        </span>
      </label>
    );
  };

  return (
    <>
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <legend className="sui-facet__title">Lieux</legend>
      </AccordionSummary>
      <AccordionDetails>
        <div>
      {searchable && (
        <div className="sui-facet-search" style={{ marginBottom: "8px" }}>
          <input
            className="sui-facet-search__text-input"
            type="search"
            placeholder={searchablePlaceholder || "Rechercher..."}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      )}

      {items.length === 0 && <div style={{ fontSize: "14px", color: "#666" }}>Aucun lieu trouvé</div>}
      {items.length > 0 && filteredItems.length === 0 && (
        <div style={{ fontSize: "14px", color: "#666" }}>Aucun lieu ne correspond à "{searchQuery}"</div>
      )}

      <List component="nav" dense disablePadding>
        {/* Valais */}
        <ListItemButton onClick={() => setOpenValais(!openValais)} dense>
          <ListItemText primary="Valais" primaryTypographyProps={{ fontWeight: "bold", fontSize: "12px" }} />
          {openValais ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openValais} timeout="auto" unmountOnExit>
          <div className="sui-multi-checkbox-facet">
            {valaisItems.map(renderItem)}
          </div>
        </Collapse>

        {/* Hors-Valais */}
        <ListItemButton onClick={() => setOpenHorsValais(!openHorsValais)} dense>
          <ListItemText primary="Hors Valais" primaryTypographyProps={{ fontWeight: "bold", fontSize: "12px" }} />
          {openHorsValais ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openHorsValais} timeout="auto" unmountOnExit>
          <div className="sui-multi-checkbox-facet">
            {horsValaisItems.map(renderItem)}
          </div>
        </Collapse>
      </List>


      {/* Tout afficher en modal */}
      <div style={{ textAlign: "right", marginTop: "8px" }}>
        <button type="button" onClick={() => { setModalMounted(true); setModalOpen(true); }} style={{ background: "none", border: "none", color: "inherit", cursor: "pointer", fontSize: "0.75rem", textDecoration: "underline" }}>
          Tout afficher
        </button>
      </div>
        </div>
      </AccordionDetails>
    </Accordion>
    {modalMounted && (
      <FacetModal
        attribute={attribute}
        title="Lieux"
        searchable={searchable}
        searchablePlaceholder={searchablePlaceholder}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        extractLabel={(label) => label && label.includes("|") ? label.split("|")[0] + " | " + label.split("|")[1] : label}
        modalLimit={showMoreLimit}
      />
    )}
    </>
  );
}
